// extracted by mini-css-extract-plugin
export default {"search_input":"SearchInput_search_input__PwvF7","search":"SearchInput_search__K9BXB"};